<template>
  <el-dialog
    class="project-progress"
    :title="step"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal="false"
    width="calc(100vw - 200px)"
  >
    <Header slot="title" :project="project" :step="step"></Header>
    <Title :project="project" :step="step"></Title>
    <div class="project-progress-content">
      <div class="project-progress-content-left">
        <!-- <div class="dialog-header-box"><Header :project="project"></Header></div> -->
        <PositionRecommendMark :project="project"></PositionRecommendMark>
      </div>

      <div class="project-progress-content-right"><ProjectSteps :project="project" :step="step"></ProjectSteps></div>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogVisible = false">取 消</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirm">确 定</div>
    </span> -->
  </el-dialog>
</template>
<script>
import Header from './projectProgress/Header'
import Title from './projectProgress/Title'
import ProjectSteps from './projectProgress/ProjectSteps'
import PositionRecommendMark from './projectProgress/PositionRecommendMark'

const dateFormat = require('dateformat')

export default {
  components: { Header, Title, ProjectSteps, PositionRecommendMark },
  data() {
    return {
      dialogVisible: false,
      project: {},
      step: null,
      projectDetail: [],
      radishProjectDetail: {},
      editingFeedBack: false,
      editingProjectFeedBack: false,
    }
  },
  computed: {
    defaultTab() {
      return this.$route.query.tab || ''
    },
    isCustomerManager() {
      const manger = this.project.客户开发 || []
      const flag = manger.includes(app.user.account)
      if (flag) this.toEditFeedBack() && this.toEditProjectFeedBack()
      return flag
    },
  },
  methods: {
    toEditFeedBack() {
      this.editingFeedBack = true
    },
    toEditProjectFeedBack() {
      this.editingProjectFeedBack = true
    },
    saveFeedBack() {
      this.updateProject({ 客户经理人选反馈: this.project['客户经理人选反馈'] })
    },
    saveProjectFeedBack() {
      this.updateProject({ 客户对项目反馈: this.project['客户对项目反馈'] })
    },
    async updateProject(param) {
      if (!this.project._id) return
      try {
        await window.app.service('project').modify({
          id: this.project._id,
          param,
        })
        Object.assign(this.project, param)
        this.$message({ type: 'success', message: `修改成功` })
      } catch (e) {
        this.$message.error(`update project :${e.message}`)
      }
    },
    confirm() {
      this.dialogVisible = false
    },
    async open(project, step) {
      this.project = project
      this.step = step || '职位推荐'
      console.log(step)
      this.dialogVisible = true
      this.checkProjectDetail()
      if (step === '人才搜寻') this.countRadishes()
    },
    async countRadishes() {
      const searchRadishDetail = {}
      const radishProject = this.project.radish_project || []

      searchRadishDetail.已搜寻 = radishProject.length
      const haveContacted = radishProject.filter(v => v.意向)
      searchRadishDetail.已沟通 = haveContacted.length
      const res = await app.service('radish').findByIds({ ids: radishProject.map(item => item.rid) })
      if (res.status === 'success') {
        const radishes = res.data
        searchRadishDetail.行业 = radishes.map(val => val.行业).filter(val => val)
        searchRadishDetail.公司 = radishes.map(val => val.公司).filter(val => val)
      } else this.$message.error(res.msg)
      const setObjIndustry = new Set(searchRadishDetail.行业)
      const setObjCompany = new Set(searchRadishDetail.公司)
      searchRadishDetail.行业 = [...setObjIndustry]
      searchRadishDetail.公司 = [...setObjCompany]
      this.radishProjectDetail = searchRadishDetail
    },
    checkProjectDetail() {
      const result = []
      const map = {
        项目JD: ['岗位职责', '岗位要求'],
        核心要求: ['核心要求'],
        客户关心问题: ['关注问题'],
        寻访方向: ['寻访方向'],
        客户关键决策人: ['关键面试人'],
        // '优势亮点（公司）':[],
        '优势亮点（项目）': ['职位亮点及优势'],
        阿尔法对公司认知: ['阿尔法认知'],
        面试流程及安排: ['面试安排'],
        项目标签: ['职能模块', '擅长方向', '细分职能', '目标行业', '平台', '职级', '业绩', '地域', '年龄要求', '标签'],
      }
      for (const label in map) {
        const fields = map[label]
        const obj = { label, value: false }
        fields.forEach(field => {
          const val = this.project[field]
          if (Array.isArray(val)) {
            if (val.length !== 0) obj.value = true
          } else if (val) obj.value = true
        })
        result.push(obj)
      }
      this.projectDetail = result
    },
    dateFormat(time, format) {
      return dateFormat(time, format)
    },
  },
}
</script>
<style>
.project-progress .el-dialog {
  display: flex;
  flex-direction: column;
}
.project-progress .el-dialog .el-dialog__body {
  overflow: auto;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.project-progress .el-dialog .el-dialog__body .content {
  overflow: auto;
  flex-grow: 1;
}
</style>
<style scoped>
.bolder {
  font-weight: 700;
}
.dialog-header-box {
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
}
.keep-all {
  word-break: keep-all;
  white-space: nowrap;
}
.project-detail-box {
  padding-top: 15px;
  display: flex;
  flex-wrap: wrap;
}
.project-detail {
  width: 25%;
  display: flex;
  align-items: center;
  padding: 6px;
}
.input-box {
  display: flex;
}
.input-box-left,
.input-box-right {
  display: flex;
  flex-direction: column;
}
.input-box-right {
  flex-grow: 1;
  padding: 6px;
}
.textarea-btn-box {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.project-progress-content {
  display: flex;
}
.project-progress-content-left {
  flex-grow: 1;
  padding: 4px 10px;
}
.project-progress-content-right {
  width: 240px;
  background-color: #eee;
  padding: 10px 4px;
  flex: none;
}
.dialog-content {
  display: flex;
  padding-top: 10px;
}
.dialog-content-right {
  flex-grow: 1;
  padding: 10px;
}
</style>
